import { pipe } from "fp-ts/lib/function";
import { match } from "fp-ts/lib/TaskEither";
import * as io from "io-ts";
import { ActionsObservable, combineEpics } from "redux-observable";
import { defer } from "rxjs";
import { concatMap, switchMap } from "rxjs/operators";
import { SpreadCalculation, spreadCalculationArrayDecoder } from '../decoders';
import { ofType } from "../reduxObservableUtils";
import { Dependancies } from "../storeTypes";
import { dispatchNetworkError } from "./errorHandler";

export const key = "spreadCalculation";


const getSpreadCalculationsLoadingType = "user/GET_SPREADCALCULATIONS/LOADING";
const getSpreadCalculationsSuccessType = "user/GET_SPREADCALCULATIONS/LOADED";
const getSpreadCalculationsFailedType = "user/GET_SPREADCALCULATIONS/FAILED";

const addSpreadCalculationsLoadingType = "user/ADD_SPREADCALCULATIONS/LOADING";
const addSpreadCalculationsSuccessType = "user/ADD_SPREADCALCULATIONS/LOADED";
const addSpreadCalculationsFailedType = "user/ADD_SPREADCALCULATIONS/FAILED";

export const getSpreadCalculationsLoadingAction = () =>
({
  type: getSpreadCalculationsLoadingType
} as const);

export const getSpreadCalculationsSuccessAction = (data: SpreadCalculation[]) =>
  ({ type: getSpreadCalculationsSuccessType, data } as const);

export const getSpreadCalculationsFailedAction = {
  type: getSpreadCalculationsFailedType,
} as const;

export const addSpreadCalculationsLoadingAction = (spreadCalculationList: SpreadCalculation[]) =>
({
  type: addSpreadCalculationsLoadingType, 
  spreadCalculationList
} as const);

export const addSpreadCalculationsSuccessAction = (spreadCalculations: SpreadCalculation[]) =>
  ({ type: addSpreadCalculationsSuccessType, spreadCalculations } as const);

export const addSpreadCalculationsFailedAction = {
  type: addSpreadCalculationsFailedType,
} as const;





type Action =
  | typeof getSpreadCalculationsFailedAction
  | typeof addSpreadCalculationsFailedAction

  | ReturnType<
    | typeof getSpreadCalculationsLoadingAction
    | typeof getSpreadCalculationsSuccessAction
    | typeof addSpreadCalculationsLoadingAction
    | typeof addSpreadCalculationsSuccessAction
  >;

export type State =
  | { tag: "initial" }
  | { tag: "loading" }
  | {
      tag: "loaded";
      data: SpreadCalculation[];
    }
  | { tag: "error" };

const initialState: State = { tag: "initial" };

export const reducer = (state: State = initialState, action:any): State => {
  switch (action.type) {
    case getSpreadCalculationsLoadingType:
      return {
        ...state,
        tag: "loading"
      }
    case getSpreadCalculationsSuccessType: 
      return {
        tag: "loaded",
        data: action.data
      } 
    default:
      return state;
  }
  }

  const spreadCalculationsEpic = (
    action$: ActionsObservable<Action>,
    _: any,
    deps: Dependancies
  ) =>
    action$.pipe(
      ofType(getSpreadCalculationsLoadingType),
      concatMap(() =>
        pipe(
          deps.request.get(
            `DynamicSpreadConfig`,
            spreadCalculationArrayDecoder
          ),
          match(dispatchNetworkError, (spreadCalculation: any) => {
            return getSpreadCalculationsSuccessAction(spreadCalculation);
          }),
          defer
        )
      )
    );

    const addSpreadCalculationsEpic = (
      action$: ActionsObservable<Action>,
      _: any,
      deps: Dependancies
    ) =>
      action$.pipe(
        ofType(addSpreadCalculationsLoadingType),
        switchMap((x) =>
          pipe(
            deps.request.post(
              `DynamicSpreadConfig`,
              x.spreadCalculationList,
              io.unknown
            ),
            match(dispatchNetworkError, () => getSpreadCalculationsLoadingAction()),
            defer
          )
        )
      );

export const epic = combineEpics(spreadCalculationsEpic, addSpreadCalculationsEpic);
const baseSelector: (a: any) => State = s => s[key]
export const Selectors = {
    all: baseSelector
  };